import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface CentredSpinnerProps {
    translationKey?: string,
    className?: string
}

export default function CentredSpinner({ translationKey, className }: CentredSpinnerProps) {
    const { t } = useTranslation();

    return (
        <div className={`d-flex justify-content-center align-items-center${className ? ` ${className}` : ''}`}>
            <Spinner animation="border" />
            {translationKey &&
                <h5 className="ms-2 mb-0">{t<string>(translationKey)}</h5>
            }
        </div>
    );
}
